export const CHINA = 'China';
export const HKSAR = 'Hong Kong SAR';
export const CHINA_CODE = '86';
export const EMPLOYMENT_STATUS_WORKING_OPTIONS = ['EMPLOYED_FULL_TIME', 'EMPLOYED_PART_TIME', 'SELF_EMPLOYED', 'BUSINESS_OWNER', 'EXECUTIVE_LEVEL_MANAGER'];
export const SHOW_EMPLOYMENT_ROLE = ['EXECUTIVE_LEVEL_MANAGER', 'SELF_EMPLOYED'];
export const SELF_EMPLOYED = 'SELF_EMPLOYED';
export const SHOW_EMPLOYMENT_INDUSTRY = ['SELF_EMPLOYED', 'BUSINESS_OWNER', 'EXECUTIVE_LEVEL_MANAGER'];
export const MAX_COMPANY_NAME_CHAR = 20;
export const YES = 'yes';
export const NO = 'no';
export const NOT_TIN_REASON_OPTIONS = [
  {
    value: 'REASON4',
    label: 'ICO.FINANCIAL.ISSUE'
  },
  {
    value: 'EXPLANATION1',
    label: 'ICO.FINANCIAL.WAITINGS'
  },
  {
    value: 'REASON6',
    label: 'ICO.FINANCIAL.ALLOWTIN'
  },
  {
    value: 'EXPLANATION2',
    label: 'ICO.FINANCIAL.DONTTIN'
  },
];
// USING ACCOUNT
export const ACCOUNT_SOURCE_FROM = [
  {
    value: 'FROM_YOURSELF',
    label: 'ICO.USING.YOUR_OWN_ACCOUNT'
  },
  {
    value: 'THIRD_PARTY',
    label: 'ICO.USING.ANOTHER_PERSON_COMPANY'
  }
];
export const TRANSFER_FROM_ANOTHER_ACCOUNT = 'TRANSFER_FROM_ANOTHER_ACCOUNT';
export const ANOTHER_SOURCE = 'ANOTHER_SOURCE';

export const PASSPORT = 'PASSPORT';
export const EEP = 'EXIT_ENTRY_PERMIT';
export const OTHERS = 'OTHERS';
